<template>
    <div>
        <div id="title-bg"  class="title-write" :style="{opacity:0}" ></div>
        <div  class="bar">
            <img class="back" @click="goBack" src="../../assets/images/member_new/back.png"/>
            <span class="title">{{title}}</span>
        </div>
    </div>
</template>
<script>
import { MOBILE_API } from "@/constants/api";
import {isRunInApp } from "@/utils/env";

export default {
    props:['title'],
    data(){
        return{
            isInApp:isRunInApp(),
        }
    },
    mounted(){
        console.log("isInApp",this.isInApp)

        window.addEventListener("scroll", this.handleScroll);
    },
    destroyed(){
        window.removeEventListener("scroll", this.handleScroll);
    },
    methods:{
        goBack() {
            if(this.isInApp){
                window.location.href = MOBILE_API.EXIT;
            }else{
                this.$router.go(-1);
            }
        },
        handleScroll(){
        // 得到页面滚动的距离，兼容写法
            let scrollTop =
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop;
            // 判断页面滚动的距离是否大于吸顶元素的位置
            
            document.getElementById("title-bg").style.opacity = scrollTop/44;
        },
    }
}
</script>

<style lang="scss" scoped>
.bar{
        width: 100%;
        height: calc(.88rem + constant(safe-area-inset-top));
        height: calc(.88rem + env(safe-area-inset-top));
        margin-bottom: .24rem;
        position: fixed;
        top: 0;
        z-index: 999;
        padding-top: constant(safe-area-inset-top);
        padding-top:  env(safe-area-inset-top);
        text-align: center;
        .back{
            width: .64rem;
            height: .62rem;
            position: absolute;
            left: .4rem;
            top: calc(.16rem + constant(safe-area-inset-top));
            top: calc(.16rem + env(safe-area-inset-top));
        }
        .title{
            font-size: .34rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #1B2A42;
            line-height: .88rem;
        }
    }
    .title-write{
        background-color: #FFFFFF;
        height: calc(.88rem + constant(safe-area-inset-top));
        height: calc(.88rem + env(safe-area-inset-top));
        position: absolute;
        position: fixed;
        top: 0;
        z-index: 998;
        width: 100%;
        padding-top: constant(safe-area-inset-top);
        padding-top:  env(safe-area-inset-top);
    }
</style>

